import { Extension } from '@tiptap/core';
import { PluginKey } from '@tiptap/pm/state';
import Suggestion, { SuggestionOptions } from '@tiptap/suggestion';

import { SlashCommandSuggestionItem } from './types';

export const SlashCommandPluginKey = new PluginKey('slashCommand');

export interface SlashCommandExtensionOptions {
  suggestion: Omit<SuggestionOptions<SlashCommandSuggestionItem>, 'editor'>;
}

export const SlashCommandExtension =
  Extension.create<SlashCommandExtensionOptions>({
    name: 'slashCommand',

    addOptions() {
      return {
        suggestion: {
          char: '/',
          startOfLine: false,
          allowedPrefixes: null,
          pluginKey: SlashCommandPluginKey,
          command: ({ editor, range, props }) => {
            editor
              .chain()
              .focus()
              .deleteRange(range)
              .insertContent(props.promptText)
              .run();
          },
          items: () => [],
          render: () => ({
            onStart: () => {},
            onUpdate: () => {},
            onKeyDown: () => false,
            onExit: () => {},
          }),
        },
      };
    },

    addProseMirrorPlugins() {
      return [
        Suggestion({
          editor: this.editor,
          ...this.options.suggestion,
        }),
      ];
    },
  });
